import React from 'react'
import Modal from 'react-responsive-modal'
import './style.scss'
import {
	WhatsappShareButton,
	EmailShareButton
} from "react-share";
import whatsapp from './icons/whatsapp.svg'
import messenger from './icons/messenger.svg'
import gmail from './icons/gmail.svg'

class saveTheDateModal extends React.Component {
	openFb = () => {
		window.open('https://www.facebook.com/sharer/sharer.php?u=' + encodeURIComponent(process.env.REACT_APP_PAGE + "saveTheDate/" + this.props.id))

		//window.open('fb-messenger://share?link=' + encodeURIComponent(process.env.REACT_APP_PAGE + "saveTheDate/" + this.props.id) + '&app_id=' + encodeURIComponent("1437009096459536"));
	}

	render() {
		let whatsappLink = process.env.REACT_APP_PAGE + "saveTheDate/" + this.props.id;

		let title = `${this.props.mireasa} & ${this.props.mire}, va roaga sa salvati aceasta data!`

		return (
			<Modal classNames={{
				overlay: 'modal-overlay',
				modal: 'std-modal',
				closeButton: 'modal-close-button',
			}} open={this.props.showModal} onClose={this.props.toggleModal} center>
				<div className="modal-content">
					<div id="invites" style={{ marginTop: "10vh" }}>
						<h5 style={{ textAlign: "center" }}>Trimite save the date</h5>
						<div id="icons">
							<WhatsappShareButton title={title} separator=" " url={whatsappLink} >
								<img id="whatsapp" src={whatsapp} alt="" />
							</WhatsappShareButton>

							<img onClick={this.openFb} id="messenger" src={messenger} alt="" />

							<EmailShareButton url={whatsappLink}>
								<img id="messenger" src={gmail} alt="" />
							</EmailShareButton>
						</div>
					</div>
				</div>
			</Modal>
		)
	}
}

export default saveTheDateModal;